import { render, staticRenderFns } from "./DetailsofTreatment.vue?vue&type=template&id=897d0792&scoped=true&"
import script from "./DetailsofTreatment.vue?vue&type=script&lang=js&"
export * from "./DetailsofTreatment.vue?vue&type=script&lang=js&"
import style0 from "./DetailsofTreatment.vue?vue&type=style&index=0&id=897d0792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d0792",
  null
  
)

export default component.exports